export default {
  'pages.forgotPassword.title': '找回密码',
  'pages.forgotPassword.brand': 'Liulian AI',
  'pages.forgotPassword.subtitle': '通过邮箱验证码重置您的密码',
  'pages.forgotPassword.email.placeholder': '邮箱',
  'pages.forgotPassword.email.required': '请输入邮箱',
  'pages.forgotPassword.email.invalid': '邮箱格式不正确',
  'pages.forgotPassword.captcha.placeholder': '验证码',
  'pages.forgotPassword.captcha.required': '请输入验证码',
  'pages.forgotPassword.captcha.sent': '验证码已发送至邮箱',
  'pages.forgotPassword.password.placeholder': '新密码',
  'pages.forgotPassword.password.required': '请输入新密码',
  'pages.forgotPassword.password.length': '密码长度为 4-20 位',
  'pages.forgotPassword.confirmPassword.placeholder': '确认新密码',
  'pages.forgotPassword.confirmPassword.required': '请再次输入新密码',
  'pages.forgotPassword.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.forgotPassword.step1.submit': '发送验证码',
  'pages.forgotPassword.step2.submit': '验证',
  'pages.forgotPassword.step3.submit': '修改密码',
  'pages.forgotPassword.step1.error': '操作失败，请检查邮箱后重试',
  'pages.forgotPassword.step2.error': '验证码错误，请重试',
  'pages.forgotPassword.step3.error': '密码修改失败，请重试',
  'pages.forgotPassword.success': '密码重置成功，请登录',
  'pages.forgotPassword.backHome': '返回首页',
  'pages.forgotPassword.rememberPassword': '想起密码了？ {login}',
  'pages.forgotPassword.loginNow': '立即登录',
};
